/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Likes_viewer = {|
  +favoriteNotifications?: ?{|
    +id: string;
    +hasNewEvents: ?boolean;
  |};
  +favoriteNotificationsTiles?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNewEvents",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Likes_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNotifications",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "favoriteNotificationsTiles",
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String"
            }
          ],
          "concreteType": "FavoriteNotifications",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FavNotifications_favoriteNotificationsTiles",
              "args": [
                {
                  "kind": "Variable",
                  "name": "createdAfter",
                  "variableName": "createdAfter",
                  "type": null
                },
                {
                  "kind": "Variable",
                  "name": "eventsLimit",
                  "variableName": "eventsLimit",
                  "type": null
                },
                {
                  "kind": "Variable",
                  "name": "notificationItemsLimit",
                  "variableName": "notificationItemsLimit",
                  "type": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNewEvents",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String"
            }
          ],
          "concreteType": "FavoriteNotifications",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "createdAfter",
                  "variableName": "createdAfter",
                  "type": "String"
                },
                {
                  "kind": "Variable",
                  "name": "eventsLimit",
                  "variableName": "eventsLimit",
                  "type": "Int"
                }
              ],
              "name": "hasNewEvents",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
